import React, { useEffect, useMemo } from "react";
import { FiAlertCircle } from "react-icons/fi";
import { playSystemSound } from "../audio/soundManager";

const SYSTEM_MESSAGES = [
  {
    intro: "System sync complete.",
    detail: "Your daily quests are now active.",
  },
  {
    intro: "Orders have been issued.",
    detail: "Check your daily quests and begin the run.",
  },
  {
    intro: "A new day has been registered.",
    detail: "Fresh quests have been loaded into the system.",
  },
  {
    intro: "System access confirmed.",
    detail: "Your daily quest board is ready.",
  },
  {
    intro: "Quest cycle initialized.",
    detail: "Review today’s objectives and start moving.",
  },
  {
    intro: "Status update received.",
    detail: "Your next set of daily quests has arrived.",
  },
];

const PENALTY_MESSAGES = [
  (questName) => ({
    intro: "Failure logged.",
    detail: questName
      ? `You failed to complete ${questName}. A mandate has now been issued.`
      : "Missed objective detected. A system mandate is now in effect.",
  }),
  (questName) => ({
    intro: "System alert.",
    detail: questName
      ? `${questName} was neglected. Resolve the mandate before the record worsens.`
      : "The System does not forgive idleness. Resolve the mandate or face deduction.",
  }),
  (questName) => ({
    intro: "Consequences active.",
    detail: questName
      ? `${questName} triggered disciplinary review. Compliance is now required.`
      : "A penalty cycle has begun. Compliance is required immediately.",
  }),
];

const SystemNotification = ({ ready = true, penaltyMode = false, penaltyQuestName = "" }) => {
  const message = useMemo(() => {
    if (!ready) {
      return {
        intro: "System link established.",
        detail: "Evaluating outstanding conditions. Hold position.",
      };
    }

    if (penaltyMode) {
      const builder =
        PENALTY_MESSAGES[Math.floor(Math.random() * PENALTY_MESSAGES.length)];
      return builder(penaltyQuestName);
    }

    return SYSTEM_MESSAGES[Math.floor(Math.random() * SYSTEM_MESSAGES.length)];
  }, [penaltyMode, penaltyQuestName, ready]);

  useEffect(() => {
    if (!ready) return;
    playSystemSound(penaltyMode ? "systemPenalty" : "systemNotice");
  }, [penaltyMode, ready]);

  return (
    <div
      className={[
        "system-notification-screen",
        penaltyMode ? "system-notification-screen--penalty" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div
        className={[
          "solo-system",
          "solo-system--fullscreen",
          penaltyMode ? "solo-system--fullscreen--penalty" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <span className="system-icon"><FiAlertCircle /></span>
        <div className="system-notification-copy">
          <h2>{penaltyMode ? "SYSTEM ALERT" : "NOTIFICATION"}</h2>
          <div className="quest-text system-notification-text">
            <div>[{message.intro}]</div>
            <div>{message.detail}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemNotification;
